import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const DownloadDesktopAppIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <path d="M16.6666 14.1667H3.33329V4.16673H9.99996V2.50006H3.33329C2.40829 2.50006 1.66663 3.24173 1.66663 4.16673V14.1667C1.66663 15.0834 2.40829 15.8334 3.33329 15.8334H6.66663V17.5001H13.3333V15.8334H16.6666C17.5833 15.8334 18.3333 15.0834 18.3333 14.1667V11.6667H16.6666V14.1667Z" />
    <path d="M14.1666 11.6667L18.3333 7.50006L17.1583 6.32506L15 8.47506V2.50006H13.3333V8.47506L11.175 6.32506L9.99996 7.50006L14.1666 11.6667Z" />
  </Icon>
);

export default memo(DownloadDesktopAppIcon);
